/**
 * `<cart-drawer>` custom element (roadmap v1.1, upgrade path of story 3.3).
 *
 * Opens a native <dialog> over the page: on the header cart link (progressive
 * enhancement — the link still goes to the cart page without JS) and after an
 * add to cart (`thcabina:cart-updated` from a `<product-form>` or
 * `<quick-add>`). Cart mutations coming from a `<cart-items>` elsewhere on
 * the page refresh the drawer without opening it. Focus trap, Esc and focus
 * return are the dialog's own.
 */
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
  }

  connectedCallback() {
    if (!this.dialog) return;

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-cart-drawer-open]');
      if (opener) {
        event.preventDefault();
        this.open();
        return;
      }
      if (event.target.closest('[data-cart-drawer-close]')) this.close();
    });

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });

    document.addEventListener('thcabina:cart-updated', (event) => {
      if (this.contains(event.target)) return;
      const fromCartItems = event.target instanceof Element && event.target.closest('cart-items');
      this.refresh(!fromCartItems);
    });
  }

  open() {
    if (!this.dialog.open) this.dialog.showModal();
  }

  close() {
    this.dialog.close();
  }

  refresh(thenOpen) {
    fetch(`${window.location.pathname}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const updated = doc.querySelector('cart-items');
        const current = this.querySelector('cart-items');
        if (updated && current) current.innerHTML = updated.innerHTML;
        if (thenOpen) this.open();
      })
      .catch(() => {});
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
